import {
  Box,
  Button,
  LinearProgress,
  MobileStepper,
  Typography,
  TextField,
  MenuItem,
  useTheme,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Autocomplete,
  Chip,
  Checkbox,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import { genders, profileCompleted } from "../../../static/staticdata";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-toastify";
import { FILE_TYPES } from "../ProfileForm";
import AddPhotoAlternateRoundedIcon from "@mui/icons-material/AddPhotoAlternateRounded";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { CountrySelect } from "../../../styles/styles";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useDispatch, useSelector } from "react-redux";
import { getPracticeArea } from "../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { backend_api, backend_url } from "../../../static/server";
import { getLoginUserData } from "../../../redux/Apps/Lawyerapp/DashboardSlice/DashboardSlice";

const steps = [
  { label: "Personal Details" },
  { label: "Education & Certifications" },
  { label: "Professional Details" },
  { label: "Expertise & Preference" },
];

const LawyerProfileForm = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [profileImage, setProfileImage] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("+1"); // Default country code
  const { token } = useSelector((data) => data.user);
  const { allPracticeArea } = useSelector((state) => state.case);
  const progress = profileCompleted + activeStep;
  const { LoginUserData, loading } = useSelector((state) => state.dashboard);

  console.log(profileCompleted);

  useEffect(() => {
    dispatch(
      getPracticeArea({
        url: `${backend_api}case/case-type/?case_service_type=practice_area`,
        token: token,
      })
    );
    dispatch(
      getLoginUserData({
        url: `${backend_api}lawer/update-profile-lawer/`,
        token: token,
      })
    );
  }, [dispatch, token]);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      mobile: "",
      address_1: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      experience: "",
      licenseNumber: "",
      specialization: "",
      consultationFee: "",
    },
  });

  useEffect(() => {
    if (LoginUserData) {
      Object.keys(LoginUserData)?.forEach((key) => {
        setValue(key, LoginUserData[key]);

        console.log(key);
      });

      if (LoginUserData?.avatar) {
        setProfileImage(LoginUserData?.avatar);
      }
    }
  }, [LoginUserData, setValue, setProfileImage]);

  const lawFirmOrIndependent = watch("lawFirmOrIndependent");

  const handleCountryChange = (newCode) => {
    setSelectedCountry(newCode);
  };
  const handleFileChange = (file) => {
    if (file && FILE_TYPES.includes(file.type.split("/")[1].toUpperCase())) {
      setValue("avatar", file, { shouldValidate: true });
      setProfileImage(URL.createObjectURL(file));
    } else {
      toast.error("Invalid file type! Please upload a valid image file.");
    }
  };

  const handleDeleteImage = () => {
    setProfileImage(null);
    setValue("avatar", "");
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    } else {
      handleSubmit(onSubmit)();
    }
  };

  const onSubmit = (data) => {
    console.log("Form Data:", data);
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
      }}
    >
      {/* Progress Bar */}
      <Box sx={{ width: "100%" }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ mb: 1, borderRadius: "1rem" }}
        />
      </Box>

      {/* Form Box */}
      <Box
        sx={{
          width: "100%",
          p: "1rem",
          zIndex: 5,
          borderRadius: "1rem",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          border: "1px solid #e5e5e5",
          transition: "all 0.3ms",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: "0.5rem",
          }}
        >
          <Typography
            variant="body1"
            color="primary"
            sx={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            {steps[activeStep].label}
          </Typography>
        </Box>

        {/* Form Fields */}
        <form>
          {activeStep === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box display="flex" gap="1rem">
                {/* Avatar Upload Section */}
                <Controller
                  name="avatar"
                  control={control}
                  render={({ field }) => (
                    <Box sx={{ position: "relative" }}>
                      {profileImage ? (
                        <Box
                          sx={{
                            position: "relative",
                            width: "9rem",
                            height: "9rem",
                            borderRadius: 2,
                            overflow: "hidden",
                            border: "1px dashed #dadada",
                          }}
                        >
                          <img
                            src={`${backend_url}/${profileImage}`}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              bgcolor: "rgba(0,0,0,0)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              transition: "background-color 0.3s",
                              "&:hover": {
                                bgcolor: "rgba(0,0,0,0.5)",
                                ".deletBtn": {
                                  display: "flex",
                                },
                              },
                            }}
                          >
                            <IconButton
                              onClick={handleDeleteImage}
                              className="deletBtn"
                              sx={{
                                display: "none",
                                "&:hover": { color: "red" },
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <DeleteRoundedIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      ) : (
                        <FileUploader
                          handleChange={(file) => {
                            handleFileChange(file);
                            field.onChange(file);
                          }}
                          name="avatar"
                          types={FILE_TYPES}
                          children={
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                border: "1px dashed #dadada",
                                p: 2,
                                borderRadius: 2,
                                width: "9rem",
                                height: "9rem",
                                textAlign: "center",
                              }}
                            >
                              <AddPhotoAlternateRoundedIcon
                                sx={{ fontSize: "2rem", color: "#6D6E6F" }}
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ fontSize: "0.8rem" }}
                              >
                                Upload Profile Picture
                              </Typography>
                            </Box>
                          }
                        />
                      )}
                    </Box>
                  )}
                />

                {/* Personal Information Fields */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    width: "100%",
                  }}
                >
                  {/* Name Fields */}
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <Controller
                      name="first_name"
                      control={control}
                      rules={{ required: "First name is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="First Name"
                          size="small"
                          fullWidth
                          error={!!errors.first_name}
                          helperText={errors.first_name?.message}
                        />
                      )}
                    />
                    <Controller
                      name="last_name"
                      control={control}
                      rules={{ required: "Last name is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Last Name"
                          size="small"
                          fullWidth
                          error={!!errors.last_name}
                          helperText={errors.last_name?.message}
                        />
                      )}
                    />
                  </Box>

                  {/* Date and Gender Fields */}
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <Box sx={{ width: "100%" }}>
                      <Controller
                        name="birth_date"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              field.onChange(newValue);
                            }}
                            slotProps={{
                              textField: {
                                label: "Date of Birth",
                                size: "small",
                                fullWidth: true,
                              },
                            }}
                            format="YYYY-MM-DD"
                            maxDate={dayjs()}
                          />
                        )}
                      />
                    </Box>

                    <Controller
                      name="gender"
                      control={control}
                      render={({ field }) => (
                        <FormControl size="small" fullWidth>
                          <InputLabel
                            id="gender-label"
                            sx={{ bgcolor: "#fff", px: "0.3rem" }}
                          >
                            Gender
                          </InputLabel>
                          <Select {...field} labelId="gender-label">
                            {genders?.map((item, i) => (
                              <MenuItem key={i} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Box>

                  {/* Mobile Number Field */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <CountrySelect
                      value={selectedCountry}
                      onChange={handleCountryChange}
                    />
                    <Controller
                      name="mobile"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          size="small"
                          type="number"
                          fullWidth
                          label="Mobile Number"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {selectedCountry}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
              >
                <Controller
                  name="address_1"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size="small"
                      label="Full Address"
                      placeholder="Enter the full address"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <HomeRoundedIcon sx={{ color: "#DEDEDE" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
                >
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <Controller
                      name="city"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="City"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                    <Controller
                      name="state"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="State"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <Controller
                      name="pincode"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Pin Code"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                    <Controller
                      name="country"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Country"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {activeStep === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="universityName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "University name is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="University Name"
                      variant="outlined"
                      fullWidth
                      error={!!errors.universityName}
                      helperText={errors.universityName?.message}
                    />
                  )}
                />
                <Controller
                  name="lawDegree"
                  control={control}
                  defaultValue={null}
                  rules={{ required: "Law degree is required" }}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors.lawDegree}>
                      <Autocomplete
                        options={[
                          { id: "LLB", name: "LLB" },
                          { id: "LLM", name: "LLM" },
                          { id: "JurisDoctor", name: "Juris Doctor" },
                        ]}
                        getOptionLabel={(option) => option.name}
                        value={
                          field.value
                            ? { id: field.value, name: field.value }
                            : null
                        }
                        onChange={(_, newValue) =>
                          field.onChange(newValue ? newValue.id : null)
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Law Degree"
                            size="small"
                            fullWidth
                            error={!!errors.lawDegree}
                            helperText={errors.lawDegree?.message}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                />
              </Box>
              <Controller
                name="graduationYear"
                control={control}
                defaultValue=""
                rules={{
                  required: "Graduation year is required",
                  pattern: {
                    value: /^[0-9]{4}$/, // Ensures only 4 digit numbers (valid year format)
                    message: "Please enter a valid year",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    size="small"
                    label="Graduation Year"
                    variant="outlined"
                    fullWidth
                    type="number"
                    error={!!errors.graduationYear}
                    helperText={errors.graduationYear?.message}
                  />
                )}
              />
              <Controller
                name="additionalCertifications"
                control={control}
                defaultValue={[]}
                rules={{ required: "Please select at least one certification" }}
                render={({ field }) => (
                  <FormControl
                    fullWidth
                    error={!!errors.additionalCertifications}
                  >
                    <Autocomplete
                      multiple
                      options={[
                        { id: "Mediation", name: "Mediation" },
                        { id: "Arbitration", name: "Arbitration" },
                        {
                          id: "TaxLawCertification",
                          name: "Tax Law Certification",
                        },
                      ]}
                      getOptionLabel={(option) => option.name}
                      value={
                        field.value?.map((id) =>
                          [
                            { id: "Mediation", name: "Mediation" },
                            { id: "Arbitration", name: "Arbitration" },
                            {
                              id: "TaxLawCertification",
                              name: "Tax Law Certification",
                            },
                          ].find((cert) => cert.id === id)
                        ) || []
                      }
                      onChange={(_, newValue) =>
                        field.onChange(newValue.map((item) => item.id))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderTags={(tagValues, getTagProps) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "nowrap",
                            overflowX: "auto",
                            maxHeight: "2.5rem",
                            maxWidth: "20rem",
                          }}
                        >
                          {tagValues?.map((option, index) => (
                            <Chip
                              size="small"
                              key={option?.id}
                              label={option?.name}
                              {...getTagProps({ index })}
                            />
                          ))}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Additional Certifications"
                          size="small"
                          fullWidth
                          error={!!errors.additionalCertifications}
                          helperText={errors.additionalCertifications?.message}
                        />
                      )}
                    />
                  </FormControl>
                )}
              />
            </Box>
          )}
          {activeStep === 2 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Controller
                name="lawFirmOrIndependent"
                control={control}
                defaultValue=""
                rules={{ required: "This field is required" }}
                render={({ field, fieldState }) => (
                  <FormControl component="fieldset" error={!!fieldState.error}>
                    <FormLabel component="legend">
                      Law Firm/Independent Practice
                    </FormLabel>
                    <RadioGroup
                      {...field}
                      aria-label="lawFirmOrIndependent"
                      name="lawFirmOrIndependent"
                      value={field.value}
                      onChange={field.onChange}
                      sx={{ display: "flex" }}
                    >
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        <FormControlLabel
                          value="lawFirm"
                          control={<Radio />}
                          label="Law Firm"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.8rem",
                              fontWeight: 500,
                              color: "text.secondary",
                            },
                          }}
                        />
                        <FormControlLabel
                          value="independent"
                          control={<Radio />}
                          label="Independent Practice"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.8rem",
                              fontWeight: 500,
                              color: "text.secondary",
                            },
                          }}
                        />
                      </Box>
                    </RadioGroup>
                    <FormHelperText>{fieldState.error?.message}</FormHelperText>
                  </FormControl>
                )}
              />
              {lawFirmOrIndependent === "lawFirm" && (
                <Box sx={{ display: "flex", gap: "1rem" }}>
                  <Controller
                    name="previousLawFirm"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Previous law firm is required",
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        size="small"
                        label="Previous Law Firms"
                        variant="outlined"
                        fullWidth
                        error={!!errors.previousLawFirm}
                        helperText={errors.previousLawFirm?.message}
                      />
                    )}
                  />
                  <Controller
                    name="positionHeld"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Position held is required" }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        size="small"
                        label="Position Held"
                        variant="outlined"
                        fullWidth
                        error={!!errors.positionHeld}
                        helperText={errors.positionHeld?.message}
                      />
                    )}
                  />
                </Box>
              )}
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="barCouncilRegistrationNumber"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Bar Council Registration Number is required",
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="Bar Council Registration Number"
                      variant="outlined"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                <Controller
                  name="yearsOfExperience"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Years of experience is required",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Please enter a valid number",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="Years of Experience"
                      variant="outlined"
                      fullWidth
                      type="number"
                      error={!!errors.yearsOfExperience}
                      helperText={errors.yearsOfExperience?.message}
                    />
                  )}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="barLicenseStatus"
                  control={control}
                  render={({ field }) => (
                    <FormControl size="small" fullWidth>
                      <InputLabel
                        id="barLicenseStatus-label"
                        sx={{ bgcolor: "#fff", px: "0.3rem" }}
                      >
                        Bar License Status
                      </InputLabel>
                      <Select {...field} labelId="barLicenseStatus-label">
                        <MenuItem value="licensed">Licensed</MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="not-licensed">Not Licensed</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
                <Controller
                  name="licenseNumber"
                  control={control}
                  defaultValue=""
                  rules={{ required: "License number is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="License Number"
                      variant="outlined"
                      fullWidth
                      error={!!errors.licenseNumber}
                      helperText={errors.licenseNumber?.message}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
              >
                <Controller
                  name="jurisdiction"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Jurisdiction"
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  )}
                />
                <Controller
                  name="practice_area"
                  control={control}
                  render={({ field }) => (
                    <FormControl size="small" fullWidth>
                      <Autocomplete
                        multiple
                        size="small"
                        fullWidth
                        options={allPracticeArea || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={
                          allPracticeArea?.filter((option) =>
                            field?.value?.includes(option?.id)
                          ) || []
                        }
                        onChange={(_, newValue) =>
                          field.onChange(newValue.map((item) => item.id))
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.id === value?.id
                        }
                        renderTags={(tagValues, getTagProps) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              maxHeight: "2.5rem",
                              maxWidth: "20rem",
                            }}
                          >
                            {tagValues?.map((option, index) => (
                              <Chip
                                size="small"
                                key={option?.id}
                                label={option?.name}
                                {...getTagProps({ index })}
                              />
                            ))}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Best Practice Areas"
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  )}
                />
                <Controller
                  name="courtAffiliations"
                  control={control}
                  defaultValue={[]}
                  rules={{
                    required: "Please select at least one court affiliation",
                  }}
                  render={({ field }) => (
                    <FormControl fullWidth error={!!errors.courtAffiliations}>
                      <Autocomplete
                        multiple
                        options={[
                          { id: "LocalCourt", name: "Local Court" },
                          { id: "HighCourt", name: "High Court" },
                          { id: "SupremeCourt", name: "Supreme Court" },
                        ]}
                        getOptionLabel={(option) => option.name}
                        value={
                          field.value?.map((id) =>
                            [
                              { id: "LocalCourt", name: "Local Court" },
                              { id: "HighCourt", name: "High Court" },
                              { id: "SupremeCourt", name: "Supreme Court" },
                            ].find((court) => court.id === id)
                          ) || []
                        }
                        onChange={(_, newValue) =>
                          field.onChange(newValue.map((item) => item.id))
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        renderTags={(selected, getTagProps) =>
                          selected.map((option, index) => (
                            <Chip
                              size="small"
                              key={option.id}
                              label={option.name}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label="Court Appearance"
                            fullWidth
                            error={!!errors.courtAffiliations}
                            helperText={errors.courtAffiliations?.message}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                />
                <Controller
                  name="typesOfCasesHandled"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Please specify types of cases handled" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Types of Cases Handled"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={2}
                      error={!!errors.typesOfCasesHandled}
                      helperText={errors.typesOfCasesHandled?.message}
                    />
                  )}
                />
              </Box>
            </Box>
          )}
          {activeStep === 3 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="location"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label=" Preference Location"
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  )}
                />
                <Controller
                  name="languages"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Languages Spoken"
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  )}
                />
              </Box>

              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="salary"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Expected Salary"
                      type="number"
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  )}
                />
                <Controller
                  name="billingPreference"
                  control={control}
                  render={({ field }) => (
                    <FormControl size="small" fullWidth>
                      <InputLabel
                        id="billingPreference-label"
                        sx={{ bgcolor: "#fff", px: "0.3rem" }}
                      >
                        Billing Preference
                      </InputLabel>
                      <Select {...field} labelId="billingPreference-label">
                        <MenuItem value="hourly">Hourly</MenuItem>
                        <MenuItem value="fixed">Fixed</MenuItem>
                        <MenuItem value="contingency">Contingency</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Box>

              <Controller
                name="employmentType"
                control={control}
                rules={{ required: "Employment Type is required" }}
                render={({ field }) => (
                  <FormControl size="small" fullWidth>
                    <InputLabel
                      id="gender-label"
                      sx={{ bgcolor: "#fff", px: "0.3rem" }}
                    >
                      Employment Type & Work Preference
                    </InputLabel>
                    <Select {...field} labelId="gender-label">
                      <MenuItem value="full-time-remote">
                        Full-Time (Remote)
                      </MenuItem>
                      <MenuItem value="full-time-hybrid">
                        Full-Time (Hybrid)
                      </MenuItem>
                      <MenuItem value="full-time-in-person">
                        Full-Time (In-Person)
                      </MenuItem>
                      <MenuItem value="freelance-remote">
                        Freelance (Remote)
                      </MenuItem>
                      <MenuItem value="freelance-hybrid">
                        Freelance (Hybrid)
                      </MenuItem>
                      <MenuItem value="freelance-in-person">
                        Freelance (In-Person)
                      </MenuItem>
                      <MenuItem value="remote-only">Remote Only</MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Controller
                  name="courtAppearances"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field.value} />}
                      label="Available for Court Appearances"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.8rem",
                          fontWeight: 500,
                          color: "text.secondary",
                        },
                      }}
                    />
                  )}
                />

                <Controller
                  name="travelWillingness"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field.value} />}
                      label="Willing to Travel for Cases"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "0.8rem",
                          fontWeight: 500,
                          color: "text.secondary",
                        },
                      }}
                    />
                  )}
                />
              </Box>
            </Box>
          )}
          {/* {activeStep === 4 && (
           
          )} */}
          {/* {activeStep === 5 && (
          
          )} */}
        </form>
      </Box>

      {/* Stepper & Navigation */}
      <Box sx={{ width: "100%" }}>
        <MobileStepper
          variant="dots"
          steps={steps.length}
          position="static"
          activeStep={activeStep}
          sx={{ flexGrow: 1, boxShadow: "none" }}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === steps.length - 1}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeftRoundedIcon />
              ) : (
                <KeyboardArrowRightRoundedIcon />
              )}
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRightRoundedIcon />
              ) : (
                <KeyboardArrowLeftRoundedIcon />
              )}
              Back
            </Button>
          }
        />
      </Box>
    </Box>
  );
};

export default LawyerProfileForm;
